module.exports = __webpack_public_path__ + "373c76b0eff01e85ec4d8fa42a3a610b.svg";